<template>
  <div>
    <template-setting-name :templateId="templateId"></template-setting-name>

    <template-setting-folder :templateId="templateId"></template-setting-folder>

    <template-setting-overlay :templateId="templateId"></template-setting-overlay>

    <slot></slot>

    <template-setting-delete :templateId="templateId"></template-setting-delete>
  </div>
</template>

<script>
  import TemplateSettingDelete from './template-setting-delete.vue'
  import TemplateSettingFolder from './template-setting-folder.vue'
  import TemplateSettingName from './template-setting-name.vue'
  import TemplateSettingOverlay from './template-setting-overlay.vue'

  export default {
    components: {TemplateSettingDelete, TemplateSettingFolder, TemplateSettingName, TemplateSettingOverlay},
    props: ['templateId']
  }
</script>



// WEBPACK FOOTER //
// src/components/template-settings/template-settings.vue